module.exports = __webpack_public_path__ + "img/Case_13.200ed6e0.jpg";